import { twMerge } from "tailwind-merge";
import { ICompany } from "../../../store/@types/company";

type ICompanyCard = {
  company: ICompany | null;
};

export const CompanyCard = ({ company }: ICompanyCard) => {
  const statusColor =
    company?.status === "0"
      ? "bg-red-50 text-red-500"
      : "bg-primary-50/10 text-primary-500";

  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12">
      <div
        className="h-96 w-full bg-cover bg-center relative rounded-2xl overflow-hidden"
        style={{
          backgroundImage: `url('https://cdn.pixabay.com/photo/2016/11/19/13/08/business-1839191_960_720.jpg || ${company?.banner}')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/50 to-transparent">
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <h4 className="text-2xl font-semibold text-white capitalize">
              {company?.company_name}
            </h4>
            <p className="text-white">{company?.company_website}</p>
          </div>
        </div>
      </div>

      <div className="xl:col-span-2">
        <div className="h-full p-6 space-y-6 rounded-2xl bg-white">
          {/* <InfoItem label="RC Number" value={company?.rc_number} /> */}

          <div>
            <span className="text-sm text-gray-500 font-medium uppercase">
              RC Number
            </span>
            <p className="text-base font-normal px-4 py-2 bg-[#dbe5dd]/50 rounded-lg uppercase">
              {company?.rc_number}
            </p>
          </div>
          <div className="grid lg:grid-cols-2 gap-4">
            <InfoItem label="Email" value={company?.company_email} />
            <InfoItem label="Phone" value={company?.company_phone} />

            <InfoItem label="Branches" value={company?.branch?.length || 0} />
            <InfoItem
              label="Date Registered"
              value={
                company?.created_at
                  ? new Date(company.created_at).toLocaleDateString()
                  : "N/A"
              }
            />
            <InfoItem
              label="Status"
              value={
                company?.status === "0" ? (
                  <span
                    className={twMerge(
                      "px-3 py-1 text-sm rounded-full font-medium",
                      statusColor,
                    )}
                  >
                    Inactive
                  </span>
                ) : (
                  <span
                    className={twMerge(
                      "px-3 py-1 text-sm rounded-full font-medium",
                      statusColor,
                    )}
                  >
                    Active
                  </span>
                )
              }
            />
            <InfoItem
              label="Plan"
              value={company?.premium_status === "1" ? "Premium" : "Basic"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

type IInfoItem = {
  label: string;
  value: string | number | undefined | React.ReactNode;
};

const InfoItem = ({ label, value }: IInfoItem) => (
  <div>
    <span className="text-sm text-gray-500 font-medium uppercase">{label}</span>
    <p className="text-base font-normal">{value}</p>
  </div>
);
